import { render, staticRenderFns } from "./pricing.vue?vue&type=template&id=7afce13e&scoped=true"
import script from "./pricing.vue?vue&type=script&lang=js"
export * from "./pricing.vue?vue&type=script&lang=js"
import style0 from "./pricing.vue?vue&type=style&index=0&id=7afce13e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afce13e",
  null
  
)

export default component.exports